import { Button, Modal } from "react-bootstrap";
import SvgTrash from "../icons/svg/SvgTrash";
import { useTranslation } from "react-i18next";
import { SolarGlobalBoldDuotone } from "../icons/SolarGlobalBoldDuotone";
import spinnerTitle from "../others/spinnerTitle";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import env from "../../utils/helpers/functions/env";
import * as apiSite from "../../api/apiSite";
import { useToast } from "../../context/ToastContext";

const PublishedSiteDlg = ({showPublishedDlg, setShowPublishedDlg}) => {

    const { t } = useTranslation(); 
    const { showToast } = useToast();
    const [ publishing, setPublishing ] = useState(false);
    const [ finished, setFinished ] = useState(false);
    const [ showButton, setShowButton ] = useState(true);

    // Публікація сайту
    const handlePublishing = async () =>{
        setPublishing(true);
        setFinished(false);
        const resPublish = await apiSite.publish();
        if (resPublish) {
            setPublishing(false)
            setFinished(true);
            setShowButton(false);    
        } else showToast(t('messError'), 'danger');
        setPublishing(false)
    }

    const handleClose = () =>{ 
        setShowPublishedDlg(false)
    }
 
    useEffect(()=>{
        if (!showPublishedDlg) setTimeout(() => {
            setFinished(false);
        }, 500); 
    },[showPublishedDlg])

    return (
    <Modal 
        show={showPublishedDlg} 
        onShow={()=>{
            setPublishing(false);
            setFinished(false);
            setShowButton(true);
        }}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton={!publishing}>
            <Modal.Title>{t('ModalContext.typeDlg.confirm')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <AnimatePresence mode="wait">
        {!finished ? (
            <motion.div
                key="element1"
                animate={{ opacity: 1, x: 0 }}
                
                transition={{ duration: 0.4 }}>
                <h4 className={`d-flex pb-3 mb-1 border-bottom text-primary fade ${!finished ? 'show' : 'd-none'}`}>
                    <SolarGlobalBoldDuotone/>
                    <span className="ps-2">{t('ToolBar.publicationSite')}?</span>
                </h4>
                <span className="form-text text-muted fs-14">
                    {t('ToolBar.publicationInfo')}
                </span>
            </motion.div>
            ) : (
            <motion.div
                key="element2"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.4 }}
                
            >
                <h4 className={`d-flex pb-3 mb-1 border-bottom text-success fade ${finished ? 'show' : 'd-none'}`}>
                    <SolarGlobalBoldDuotone/>
                    <span className="ps-2">{t('ToolBar.publishedSite')}</span>
                </h4>
                <span className="form-text fs-14 text-truncate d-block">
                    {t('ToolBar.publishedVisit')}:
                    <a  className="text-truncate"
                        href={env('REACT_APP_PUBLICSITE')}
                        target="_blank" > {env('REACT_APP_PUBLICSITE')}</a> 
                </span>
            </motion.div>
            )}
        </AnimatePresence>
     

        </Modal.Body>
        <Modal.Footer>
            <Button 
                variant="secondary" 
                disabled={publishing}
                onClick={handleClose}>
            {t('buttons.close')}
            </Button>

            {showButton && (
            <Button 
                variant="primary" 
                disabled={publishing}
                onClick={handlePublishing}>
            {spinnerTitle(t('ToolBar.btnPublish'), publishing, t('ToolBar.btnPublishing'))}
            </Button>)}
        </Modal.Footer>
      </Modal>
    )
}

export default PublishedSiteDlg;